var app = angular.module("leonardo");

var AdminAccountListController = function ($scope, $state, $controller, ngDialog, AccountService, FilterService,
  AccountRequestService, AuthDataService, $q, WhiteLabelService, ClientInstanceService) {

  $scope.isRequest = $state.current.request;
  $scope.authDataService = AuthDataService;
  $scope.service = $scope.isRequest ? AccountRequestService : AccountService;

  $scope.getEntitiesPromise = function (options) {
    options = options ? options : {};
    options['summary'] = true;
    if (options && options.ordering == "client_instance__name") {
      options['order_by_clientinstance_name'] = 'asc';
      delete options.ordering;
    }
    else if (options && options.ordering == "-client_instance__name") {
      options['order_by_clientinstance_name'] = 'desc';
      delete options.ordering;
    }
    if (FilterService.hasFilter('status')) {
      options.status = FilterService.getFilter('status');
    }
    if (FilterService.hasFilter('sector')) {
      options.sector = FilterService.getFilter('sector');
    }
    if (FilterService.hasFilter('search')) {
      options.search = FilterService.getFilter('search');
    }
    if (FilterService.hasFilter('client_instances', true)) {
      options.client_instance = FilterService.getFilter('client_instances', true);
    }
    return $scope.service.getlist(options);
  };

  function UpdateCollection(data) {
    if (!$state.current.request) {
      AccountService.updateCollection(data);
    }
    $scope.loadPage($scope.page);
  }

  $scope.confirm = function (account) {
    ngDialog.openConfirm({
      template: 'views/templates/admin/account/dialog/confirm.html',
      controller: 'AdminAccountConfirmDialogController',
      scope: $scope,
      data: { account: account }
    }).then(function (data) {
      UpdateCollection(data);
    });
  };

  $scope.reject = function (account) {
    ngDialog.openConfirm({
      template: 'views/templates/admin/account/dialog/reject.html',
      controller: 'AdminAccountRejectDialogController',
      scope: $scope,
      data: { account: account }
    }).then(function () {
      $scope.loadPage($scope.page);
    });
  };

  $scope.showEditAccount = function (account) {
    const isWhiteLabelEnabled = (account.account_client_instance_mappings) ? account.account_client_instance_mappings.status : false;
    const all = [
      AccountService.get(account.id),
      isWhiteLabelEnabled ? WhiteLabelService.get(account.account_client_instance_mappings.white_label, true) : [],
      account.account_client_instance_mappings?.client_instance_id ? ClientInstanceService.get(account.account_client_instance_mappings?.client_instance_id, true) : []
    ];
    $q.all(all).then(function (data) {
      ngDialog.openConfirm({
        template: 'views/templates/admin/account/dialog/edit.html',
        className: 'ngdialog-theme-default ngdialog-white-label-edit',
        controller: 'EditAccountDialogController',
        data: { account: data[0], whitelabel: data[1], clientinstance: data[2] }
      }).then(function () {
        UpdateCollection(data);
      });
    });
  };

  $scope.showDeleteAccount = function (account) {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/delete.html',
      controller: 'DeleteDialog',
      data: {
        object: account,
        type: 'account'
      }
    }).then(function (data) {
      if (!$state.current.request) {
        AccountService.updateCollection(data, true);
      }
      $scope.loadPage($scope.page);
    });
  };

  $scope.accountIsPending = function (account) {
    return account.status == $scope.service.STATUS_PENDING;
  };
  
  $controller('TableFilterController', { $scope: $scope });

  $scope.loadPage(1);
};

app.controller('AdminAccountListController', ['$scope', '$state', '$controller', 'ngDialog', 'AccountService',
  'FilterService', 'AccountRequestService', 'AuthDataService', '$q', 'WhiteLabelService', 'ClientInstanceService', AdminAccountListController]);
